import React from "react";

interface IconProps {
    active?: boolean;
    size?: number;
}

/** Sidebar section icon — stroke style shared with the mobile tab bar. */
const IconModule: React.FC<IconProps> = ({ active = false, size = 24 }) => {
    const color = active ? "#0F7679" : "#6A7878";
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.5" y="3.5" width="13" height="13" rx="3"/><path d="M10 7v6M7 10h6"/>
        </svg>
    );
};

export default IconModule;
